(function () {
	var productGallerySwipers = [];
	var reviewGallerySwipers = [];

	function destroyProductGalleries() {
		productGallerySwipers.forEach(function (swiper) {
			if (swiper && typeof swiper.destroy === 'function') {
				swiper.destroy(true, true);
			}
		});

		productGallerySwipers = [];
	}

	function destroyReviewGalleries() {
		reviewGallerySwipers.forEach(function (swiper) {
			if (swiper && typeof swiper.destroy === 'function') {
				swiper.destroy(true, true);
			}
		});

		reviewGallerySwipers = [];
	}

	function initProductGallery(popup) {
		if (!popup) {
			return;
		}

		destroyProductGalleries();

		var mainEl = popup.querySelector('[data-target="product-popup-slider"]');
		var thumbsEl = popup.querySelector('[data-target="product-popup-thumbs"]');

		if (!mainEl) {
			return;
		}

		var thumbsSwiper = null;

		if (thumbsEl) {
			thumbsSwiper = new Swiper(thumbsEl, {
				slidesPerView: 'auto',
				spaceBetween: 10,
				watchSlidesProgress: true,
			});

			productGallerySwipers.push(thumbsSwiper);
		}

		var mainSwiper = new Swiper(mainEl, {
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: mainEl.querySelector('.swiper-pagination'),
				type: 'fraction',
			},
			thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
		});

		productGallerySwipers.push(mainSwiper);
	}

	function initReviewGallery(popup) {
		if (!popup) {
			return;
		}

		destroyReviewGalleries();

		var mainEl = popup.querySelector('[data-target="review-popup-slider"]');
		var thumbsEl = popup.querySelector('[data-target="review-popup-thumbs"]');

		if (!mainEl) {
			return;
		}

		var thumbsSwiper = null;

		if (thumbsEl) {
			thumbsSwiper = new Swiper(thumbsEl, {
				slidesPerView: 'auto',
				spaceBetween: 12,
				watchSlidesProgress: true,
			});

			reviewGallerySwipers.push(thumbsSwiper);
		}

		var mainSwiper = new Swiper(mainEl, {
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: mainEl.querySelector('.swiper-pagination'),
				type: 'fraction',
			},
			thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
		});

		reviewGallerySwipers.push(mainSwiper);
	}

	function resetPopupTabs(popup) {
		var panel = popup.querySelector('[data-target="product-tab-panel"]');

		if (!panel) {
			return;
		}

		var firstBtn = panel.querySelector('[data-target="product-tab-button"]');

		if (!firstBtn) {
			return;
		}

		panel.querySelectorAll('[data-target="product-tab-button"]').forEach(function (btn) {
			var isActive = btn === firstBtn;

			btn.classList.toggle('tab-panel__btn_active', isActive);
			btn.setAttribute('aria-selected', String(isActive));
		});

		panel.querySelectorAll('[data-target="product-tab"]').forEach(function (tab) {
			var isActive = tab.dataset.tab === firstBtn.dataset.tab;

			tab.classList.toggle('tab-panel__tab_active', isActive);
			tab.hidden = !isActive;
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.addEventListener('click', function (event) {
			var openModal = event.target.closest('[data-action="product-modal"]');
			var openReview = event.target.closest('[data-target="review-modal"]');

			if (openReview) {
				event.preventDefault();

				var href = openReview.getAttribute('href');
				var popup = href ? document.querySelector(href) : null;

				if (!popup) {
					return;
				}

				Fancybox.close();
				Fancybox.show([{
					src: href,
					type: 'inline',
				}], {
					closeButton: false,
					dragToClose: false,
					on: {
						done: function () {
							initReviewGallery(document.querySelector(href));
						},
						destroy: function () {
							destroyReviewGalleries();
						},
					},
				});

				return;
			}

			if (!openModal) {
				return;
			}

			event.preventDefault();

			var card = openModal.closest('[data-product-id]');
			var productId = (card && card.dataset.productId) || openModal.dataset.productId;

			if (!productId) {
				return;
			}

			var popupSelector = '#popup-product-' + productId;
			var popup = document.querySelector(popupSelector);

			if (!popup) {
				return;
			}

			Fancybox.close();
			Fancybox.show([{
				src: popupSelector,
				type: 'inline',
			}], {
				closeButton: false,
				dragToClose: false,
				on: {
					done: function () {
						var activePopup = document.querySelector(popupSelector);

						resetPopupTabs(activePopup);
						initProductGallery(activePopup);
					},
					destroy: function () {
						destroyProductGalleries();
					},
				},
			});
		});
	});
})();
